import { getLoginPage } from "../../../config/loginContent.js";
import { buildAnimatedTitle } from "../../HeroTitleAnimation.js";

export function createLoginHeroSection() {
  const { hero } = getLoginPage();
  const section = document.createElement("section");
  section.id = "hero";
  section.className = "section hero login-hero";

  section.innerHTML = `
    <div class="section__inner login-hero__inner">
      <div class="login-hero__content reveal">
        <h1 class="hero__title">${buildAnimatedTitle(hero.titleSegments)}</h1>
        <p class="hero__subtitle">${hero.subtitle}</p>
      </div>
    </div>
  `;

  return section;
}
